module.exports = function(app) {
	app.run(['Service', 'employee', '$filter', '$q', 'planAdmin', 'coverageBuddy','sessionData',
		function (Service, employee, $filter, $q, planAdmin, coverageBuddy, sessionData) {

			return new Service({
				name: 'additionalGroupInformation',
				group: 'eprsvc',
				url: '/eprsvc/x-services/secure/group-information/v1/:groupNumber/additional',
				cache: true,

				fetch: function(effectiveDate) {
					var groupNumber = this.url.split('v1/')[1].split('/')[0];
					var isUCCI = planAdmin.getUCCIGroupNumbers().some(function(n) {
						return  n == groupNumber;
					});
					if (isUCCI || !groupNumber) {
						return $q.when({ payload: {} });
					}
					if (effectiveDate && effectiveDate instanceof Date) {
						effectiveDate = $filter('date')(effectiveDate, 'yyyy-MM-dd');
					}
					if (
						effectiveDate &&
						effectiveDate.indexOf &&
						effectiveDate.indexOf('Z') >= 0
					) {
						effectiveDate = $filter('date')(new Date(effectiveDate), 'yyyy-MM-dd');
					}
					var queryParams = effectiveDate && { effectiveDate: effectiveDate };
                    if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                        this.headers['ClientNumber']  = sessionData.clientNumber;
                    }
					return this.get(queryParams);
				},

				getEffectiveDate: function(groupNumber, participant) {
					participant = participant || employee.data.subscriber;

					var dss = coverageBuddy.getCoveragesByGroupNumber(participant, groupNumber).map(
						function(coverage) {
							return (coverage.memberLobs || []).map(function(lob) { return lob.coverageEffectiveDate; });
						}
					);

					var ds = dss.reduce( function(p, n) { return p.concat(n); }, []);
					ds = ds.filter(function(date) { return date; });
					ds = ds.map(function(d) { return $filter('dateInput')(d); });
					var latestDate = ds.reduce(function(p, n) { return n >= p ? n : p; }, new Date());

					return $filter('date')(latestDate, 'yyyy-MM-dd');
				}
			});
		}
	]);
};
